import { gql } from "@apollo/client"

export const DeleteDelivery = gql`
mutation Mutation($deleteDeliveryId: ID!) {
  deleteDelivery(id: $deleteDeliveryId) {
    status
  }
}
`